export const getYouTubeId = (input) => {
  if (!input) return '';
  const m = String(input).match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
  return m ? m[1] : String(input).trim();
};

export const formatINR = (n) => `₹${Number(n || 0).toLocaleString('en-IN')}`;
